import { useEffect, useState } from "react";
/** Refresh date-driven groups at local midnight, including DST changes. */
export function useLocalCalendarDay(): Date {
  const [day, setDay] = useState(() => new Date());
  useEffect(() => {
    const now = new Date();
    const next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const timer = window.setTimeout(
      () => setDay(new Date()),
      next.getTime() - now.getTime() + 1,
    );
    return () => window.clearTimeout(timer);
  }, [day]);
  return day;
}
